<script setup lang="ts">
import type { MorningTheme } from '~~/shared/types/morning'
import { fallbackLogoSource } from '~~/shared/utils/branding'

const props = defineProps<{
  name: string
  logo: string
  locale: string
  showDate: boolean
  theme: MorningTheme
}>()

defineEmits<{ cycleTheme: [] }>()

const formattedDate = computed(() =>
  new Intl.DateTimeFormat(props.locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(new Date()),
)
const logoSource = ref(props.logo)
watch(
  () => props.logo,
  (value) => (logoSource.value = value),
)

function useFallbackLogo() {
  logoSource.value = fallbackLogoSource(logoSource.value)
}
</script>

<template>
  <div
    class="brand-row"
    :class="{ 'brand-row--without-date': !showDate }"
  >
    <NuxtLink
      class="brand"
      to="/"
      :aria-label="`${name}, accueil`"
    >
      <img
        :src="logoSource"
        alt=""
        @error="useFallbackLogo"
      />
      <span>{{ name }}</span>
    </NuxtLink>
    <p
      v-if="showDate"
      class="date-line"
    >
      {{ formattedDate }}
    </p>
    <DashboardHeaderActions
      :theme="theme"
      @cycle-theme="$emit('cycleTheme')"
    />
  </div>
</template>
